import React from "react";
import { motion } from "framer-motion";
import { Fingerprint, ShieldCheck, Stack } from "@phosphor-icons/react";

/**
 * Numbered manifesto chapters. Editorial, calm, opinionated.
 */
const CHAPTERS = [
  {
    n: "01",
    title: "Editable context",
    body: "Edit what your AI sees. Add, remove, or rewrite messages, then branch from any point without losing the original.",
    icon: Stack,
  },
  {
    n: "02",
    title: "Work that continues",
    body: "The runtime keeps sessions, approvals, queued inputs, and events alive—even when the Inspector is closed.",
    icon: ShieldCheck,
  },
  {
    n: "03",
    title: "Visible control",
    body: "See exactly what your AI receives and every tool call it makes.",
    icon: Fingerprint,
  },
];

export default function NotAnotherChat() {
  return (
    <section
      id="manifesto"
      data-testid="not-another-chat"
      className="relative px-6 md:px-14 py-12 md:py-16 border-t border-ink-10"
    >
      <div className="w-full max-w-[1400px] mx-auto">
        <div className="w-full flex flex-col">
          {CHAPTERS.map((c) => {
            const Icon = c.icon;

            return (
              <motion.article
                key={c.n}
                data-testid={`chapter-${c.n}`}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-15% 0px" }}
                transition={{
                  duration: 0.9,
                  ease: [0.16, 1, 0.3, 1],
                  delay: 0.05,
                }}
                className="group relative py-10 md:py-14 border-t border-ink-10 first:border-t-0 flex flex-col items-center text-center"
              >
                <div className="mb-5 md:absolute md:left-0 md:top-10 md:mb-0">
                  <div className="font-sans font-light text-5xl md:text-7xl leading-none text-ink-10 transition-colors duration-300 group-hover:text-[hsl(38_92%_55%)]">
                    {c.n}
                  </div>
                </div>
                <div className="w-full min-w-0 flex flex-col items-center">
                  <div className="flex items-center justify-center gap-4">
                    <Icon
                      size={32}
                      weight="regular"
                      aria-hidden="true"
                      className="shrink-0 text-[#355846]"
                    />
                    <h3 className="font-serif text-3xl md:text-5xl leading-none tracking-tight">
                      {c.title}
                    </h3>
                  </div>
                  <p className="mt-6 mx-auto max-w-[68ch] text-center text-xl md:text-2xl text-ink-70 leading-[1.45]">
                    {c.body}
                  </p>
                </div>
              </motion.article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
